module.exports = __webpack_public_path__ + "img/grand-cancun-room.b384d2b2.jpg";